<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="110px">
      <el-form-item label="访问地址">
        <a :href="agreementUrl+12" target="_blank" rel="noopener noreferrer">{{ agreementUrl+12 }}</a>
      </el-form-item>
      <el-form-item label="web隐私协议" prop="privacyAgreement">
        <myEditor v-model="form.privacyAgreement" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl+13" target="_blank" rel="noopener noreferrer">{{ agreementUrl+13 }}</a>
      </el-form-item>
      <el-form-item label="web服务协议" prop="userAgreement">
        <myEditor v-model="form.userAgreement" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl+14" target="_blank" rel="noopener noreferrer">{{ agreementUrl+14 }}</a>
      </el-form-item>
      <el-form-item label="web物流协议" prop="logisticsAgreement">
        <myEditor v-model="form.logisticsAgreement" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl+15" target="_blank" rel="noopener noreferrer">{{ agreementUrl+15 }}</a>
      </el-form-item>
      <el-form-item label="web网商协议" prop="myBankAgreement">
        <myEditor v-model="form.myBankAgreement" :disabled="false" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import myEditor from "@/components/MyEditor";

export default {
  name: "SiteEdit",
  components: {
    myEditor,
  },
  data() {
    return {
      agreementUrl: this.BASE_API_URL + "agreement/agreement.html?agreementType=",
      form: {
        code: "",
        privacyAgreement: "",
        myBankAgreement: "",
        logisticsAgreement: "",
        userAgreement: "",
      },
      rules: {
        privacyAgreement: [
          { required: true, message: "请输入隐私协议", trigger: "blur" },
        ],
        myBankAgreement: [
          { required: true, message: "请输入网商协议", trigger: "blur" },
        ],
        logisticsAgreement: [
          { required: true, message: "请选择物流协议", trigger: "blur" },
        ],
        userAgreement: [
          { required: true, message: "请选择服务协议", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      const rLoading = this.openLoading("获取数据中...");
      return request({
        url: `/ntocc-basic-api/agreement/getAgreement`,
        params: { agreementType: 1 },
        method: "get",
      }).then((response) => {
        if (response.data) {
          this.form.code = response.data.code;
          this.form.privacyAgreement = response.data.privacyAgreement;
          this.form.myBankAgreement = response.data.myBankAgreement;
          this.form.logisticsAgreement = response.data.logisticsAgreement;
          this.form.userAgreement = response.data.userAgreement;
        }
        rLoading.close();
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/agreement/saveAgreement",
            method: "post",
            data,
          }).then((response) => {
            this.getInfo();
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
